<template>
  <div>
    <div class="hybz_list" v-if="list.length > 0">
      <div class="hybz_item" v-for="(item, index) in list" :key="index">
        <div class="class_no fw pointer_line" @click="$goDetail(item)">
          {{ item.std_no }}
        </div>
        <div class="bz_info flex jc_sb">
          <div class="info_l flex_1 text_overflow1" :title="item.title">
            {{ item.title }}
          </div>
          <div class="info_r">
            发布时间
            {{
              item.pub_date ? $dayjs(item.pub_date).format("YYYY-DD-MM") : ""
            }}
          </div>
        </div>
      </div>
    </div>
    <img
      v-else
      style="height: 229px; margin: 0 auto"
      src="../../../assets/imgs/placeholder/no_data.png"
      alt=""
    />
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonHybz",
  props: ["list"],
  data() {
    return {};
  },

  mounted() {},

  methods: {},
};
</script>
<style lang="less" scoped>
.hybz_list {
  .hybz_item {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
    .class_no {
      font-size: 16px;
      color: #1d4a77;
      margin-bottom: 6px;
    }
    .bz_info {
      .info_l {
        font-size: 15px;
        color: #1d2541;
      }
      .info_r {
        font-size: 13px;
        color: #9a9a9a;
      }
    }
  }
}
</style>